import { render } from "./ReportSelection.vue?vue&type=template&id=95ca1600&scoped=true"
import script from "./ReportSelection.vue?vue&type=script&lang=js"
export * from "./ReportSelection.vue?vue&type=script&lang=js"

import "./ReportSelection.vue?vue&type=style&index=0&id=95ca1600&lang=css"
import "./ReportSelection.vue?vue&type=style&index=1&id=95ca1600&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95ca1600"]])

export default __exports__